export class NewsListerService {
	constructor($http, $q) {
		'ngInject';
		this.$http = $http;
		this.$q = $q;
	}

	getNewsList(params, year = null) {
		if (year) {
			params.year = year;
		}
		return this.$http.get('/news/search', {
			params: params
		});
	}

	getYears() {
		return this.$http.get('/news/years');
	}
}
